import * as tncActions from "../actionTypes/tncActionTypes"

export interface TncState {
  fileContent: string;
  version: string;
  hasAccepted: boolean;
}

const initialState: TncState = {
  fileContent: "",
  version: "",
  hasAccepted: false,
}

export const TncReducer = (
  state: TncState = initialState,
  action: tncActions.TncActions
): TncState => {
  switch (action.type) {
    case tncActions.SUBMIT_TNC_CONSENT_SUCCESS:
      return {
        ...state,
        version: action.response.version,
        hasAccepted: action.response.hasAccepted
      };
    case tncActions.GET_TNC_SUCCESS:
      return {
        ...state,
        fileContent: action.response.fileContent,
        version: action.response.version
      };
    default:
      return state
  }
}